import { registerFieldHandlersFromRecord } from "@neu/libui";
import type { FieldHandler } from "@neu/libui";

import * as brokerInvoiceEffects from "./broker_invoice";
import * as discountDrugProgramEffects from "./discount_drug_program";
import * as invoiceMailDraftEffects from "./invoice_mail_draft";
import * as overrideDrugEffects from "./override_drug";
import * as patientEffects from "./patient";
import * as patientCallEffects from "./patient_call";
import * as patientCaseEffects from "./patient_case";
import * as patientCopayProgramEffects from "./patient_copay_program";
import * as patientOrderDispenseEffects from "./patient_order_dispense";
import * as patientBiosimilarProgramEffects from "./patient_biosimilar_program";
import * as patientBridgeProgramEffects from "./patient_bridge_program";
import * as patientPapEffects from "./patient_pap";
import * as patientWelcomeCallEffects from "./patient_welcome_call";
import * as planEffects from "./plan";
import * as planGroupEffects from "./plan_group";
import * as planInvoiceEffects from "./plan_invoice";
import * as planMedicalCarrierEffects from "./plan_medical_carrier";
import * as planPbmEffects from "./plan_pbm";

const effectModules: Array<Record<string, unknown>> = [
	brokerInvoiceEffects,
	discountDrugProgramEffects,
	invoiceMailDraftEffects,
	overrideDrugEffects,
	patientEffects,
	patientCallEffects,
	patientCaseEffects,
	patientCopayProgramEffects,
	patientOrderDispenseEffects,
	patientBiosimilarProgramEffects,
	patientBridgeProgramEffects,
	patientPapEffects,
	patientWelcomeCallEffects,
	planEffects,
	planGroupEffects,
	planInvoiceEffects,
	planMedicalCarrierEffects,
	planPbmEffects,
];

export function registerFormEffectHandlers(): void {
	for (const mod of effectModules) {
		registerFieldHandlersFromRecord(mod as Record<string, FieldHandler>);
	}
}
